import React, {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import './najnovsiObsahTable.scss';
import {
  Button, Col, Link, Row,
} from 'idsk-react-components';
import './najnovsiObsahItem.scss';

interface Props {
  firstColumn: React.ReactNode;
  secondColumn: React.ReactNode;
  content?: string;
  url?: string;
  id: string;
}

const NajnovsiObsahItem = ({
  firstColumn,
  secondColumn,
  content,
  url,
  id,
}: Props): ReactElement => {
  const [showLink, setShowLink] = useState(false);
  const [wasExpanded, setWasExpanded] = useState(false);
  const [savedHeight, setSavedHeight] = useState<number | null>(null);
  const ref = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const handleResize = (): void => {
      const elem = document.getElementById(id);
      if (elem) {
        elem.classList.remove('collapsed-text');
        setSavedHeight(elem.getBoundingClientRect().height);
      }

      if (savedHeight !== null && savedHeight > 83 && elem && !wasExpanded) {
        elem.classList.add('collapsed-text');
        setShowLink(true);
      } else {
        setShowLink(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [id, savedHeight, wasExpanded]);

  const handleExpandClick = (): void => {
    const elem = document.getElementById(id);
    if (elem) {
      elem.classList.remove('collapsed-text');
      setWasExpanded(true);
    }
    setShowLink(false);
  };

  return (
    <div className="najnovsi-obsah-item">
      <Row>
        <Col width="one-half" className="first-column">
          {firstColumn}
        </Col>
        <Col width="one-half" className="second-column">
          {secondColumn}
        </Col>
      </Row>
      <Row className="row-nazov">
        <Link to={url} id={id} ref={ref}>
          {content}
        </Link>
        {showLink && (
          <Row>
            <Button
              buttonStyle="link"
              size="small"
              className="button-expand-text"
              onClick={handleExpandClick}
            >
              Rozbaliť celý názov
            </Button>
          </Row>
        )}
      </Row>
    </div>
  );
};

export default NajnovsiObsahItem;
